require("pickmeup/css/pickmeup.scss");
require("./style.scss");

const pickmeup = require("pickmeup");

pickmeup.defaults.locales["fr"] = {
    days: ["Dimanche", "Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi"],
    daysShort: ["Dim", "Lun", "Mar", "Mer", "Jeu", "Ven", "Sam"],
    daysMin: ["Di", "Lu", "Ma", "Me", "Je", "Ve", "Sa"],
    months: ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"],
    monthsShort: ["Jan", "Fév", "Mars", "Avr", "Mai", "Juin", "Juil", "Août", "Sept", "Oct", "Nov", "Déc"]
}

module.exports = pickmeup;


//////////////////
// WEBPACK FOOTER
// ./LeLab.DomaineForget.Web/src/modules/pickmeup-custom/index.js
// module id = 17
// module chunks = 0